"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateArchiveRequest = void 0;
var destination_1 = require("../job/destination");
var source_1 = require("../job/source");
/**
 * Create Archive Request
 * @doc CreateArchiveRequest
 */
var CreateArchiveRequest = /** @class */ (function () {
    function CreateArchiveRequest(data) {
        this.sources = [];
        this.destination = null;
        this.archiveType = null;
        if (!data) {
            throw new Error('No data passed to CreateArchiveRequest constructor');
        }
        this.sources = data.sources.map(function (sourceData) { return new source_1.Source(sourceData); });
        this.destination = data.destination
            ? new destination_1.Destination(data.destination)
            : null;
        this.archiveType = data.archiveType;
    }
    return CreateArchiveRequest;
}());
exports.CreateArchiveRequest = CreateArchiveRequest;
//# sourceMappingURL=create-archive-request.js.map